import { useGetAdminPlansSuspense } from '@ijoin/hooks';
import { createFileRoute } from '@tanstack/react-router';

import { ParticipantsGrid, QueryBoundary } from '../../../../components';

const Page = () => {
  const { advisoryOrganizationId } = Route.useParams();

  /** filter options are page data, so they suspend to the nearest QueryBoundary */
  const plans = useGetAdminPlansSuspense(
    advisoryOrganizationId,
    { sort: 'description' },
    {
      query: {
        select: res =>
          res.data
            .filter(p => p.planId)
            .map(p => ({ label: p.description ?? p.planId, value: p.planId }))
      }
    }
  );

  return (
    <ParticipantsGrid
      advisoryOrganizationId={advisoryOrganizationId}
      planOptions={plans.data}
    />
  );
};

export const Route = createFileRoute(
  '/organizations/$advisoryOrganizationId/participants/'
)({
  component: () => (
    <QueryBoundary>
      <Page />
    </QueryBoundary>
  )
});
